/** @format */

// Метки групп резолвятся из i18n по составному ключу `${PREFIX}.${YandexChangeGroup}`
// (см. namespace yandex_change_groups в translation.json; паттерн как provider_names).
export const GROUP_LABEL_KEY_PREFIX = 'yandex_change_groups';
